import React, { Component } from "react";
import { Row, Col } from "antd";
import sdgood from "../../assets/banner/sandee_good.png";
import "./sgn.style.css";


export default class SignOnlogo extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="sgn-mascot-section">
        <Row className="sgn-mascot-wrapper" style={{ display: "flex", alignItems: "center" }}>
          <Col
            lg={{ span: 24 }}
            xl={{ span: 24 }}
            xxl={{ span: 24 }}
          >
            <div className="sgn-mascot-background"></div>
            <img src={sdgood} alt="SANDEE Mascot" className="sgn-mascot-image" />
          </Col>
          <Col
            lg={{ span: 24 }}
            xl={{ span: 24 }}
            xxl={{ span: 24 }}
          >
            <div >
              <h1 className="sgn-main-title">SANDEE Chatbot</h1>
              <h2 className="sgn-sub-title">IT One Customer Services</h2>
            </div>

          </Col>
        </Row>
      </div>
    );
  }
}
